<script setup lang="ts">
import { Section } from "@/components/Ui";
import { BlockAffiliateHome } from "~/components/Blocks";

interface Props {
  learnMoreEvent?: string;
}

const props = defineProps<Props>();
</script>

<template>
  <Section
    id="base-affiliate"
    full-width
    :class="$style.root"
  >
    <div
      :class="$style[`root-wrapper`]"
      class="container"
    >
      <BlockAffiliateHome :learn-more-event="props.learnMoreEvent" />
    </div>
  </Section>
</template>

<style lang="scss" module>
.root {
  @apply w-full bg-neutral-900 pt-[102px] pb-[82px] text-white translate-y-[1px];
  &-wrapper {
    @apply w-full grid grid-cols-1 gap-[10px];
    @apply md:grid-cols-2;

    & > div {
      &:first-child {
        @apply md:col-span-2;
      }
    }
  }
}
</style>
